export default __webpack_public_path__ + "static/media/Powered By.18942811.svg";